/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum ProjectStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE"
}
